/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffInlineEditCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimeStaffInlineEditCtrl', ["dialog", "$filter", "ngToast", "$q", "$scope", "$state", "$stateParams", "TimeStaff", "TimeRoles", "userinfo", function(dialog, $filter, ngToast, $q, $scope, $state, $stateParams, TimeStaff, TimeRoles, userinfo) {
  $scope.currentTab = 'basic';
  var formControllers = {};
  $scope.noRolesError = false;

  var loadingPromises = {
    roles: TimeRoles.getAllActive(),
    staff: TimeStaff.get($scope.member.id)
  };

  $scope.loading = $q.all(loadingPromises);
  $scope.loading.then(function(result) {
    $scope.roles = result.roles;
    $scope.staff = result.staff;

    angular.forEach($scope.staff.paytypes, function(paytype) {
      paytype.values = JSON.parse(paytype.values);
    });

    if (!userinfo.companyHasPermission('Salary')) {
      // The active rate isn't provided without salary permisssion. Set to zero so the
      // input directive doesn't complain.
      $scope.staff.activeRemuneration.rate = 0;
    }
  }, function() {
    // Close the inline editor since this staff member has failed to load.
    $scope.member.expand = false;
  });

  /**
   * Remove hourlyrate from the role if it has not been set.
   * It is null if the user does not have payroll permissions.
   * Null hourlyrate field will break the request when it reaches the backend
   * See LOADED-1226
   */
  function removeHourlyRate() {
    $scope.staff.memberRoles.forEach(function(role) {
      if (role.hourlyRate === null) {
        delete role.hourlyRate;
      }
    });
  }

  /**
   * Send the changes to the server and return to the staff list page.
   */
  $scope.save = function() {
    if ($scope.validateForms() === false) {
      ngToast.dismiss();
      ngToast.danger('Please fix invalid fields.');
      return;
    }

    removeHourlyRate();

    $scope.saving = TimeStaff.update($scope.staff);
    $scope.saving.then(function(savedStaff) {
      // Callback to the staff list controller.
      $scope.inlineUpdate(savedStaff);
    });
  };

  $scope.deleteStaff = function() {
    if ($scope.validateForms() === false) {
      ngToast.dismiss();
      ngToast.danger('Please fix invalid fields.');
      return;
    }

    removeHourlyRate();

    $scope.deleting = TimeStaff.remove($scope.staff);
    $scope.deleting.then(function(savedStaff) {
      // Callback to the staff list controller.
      $scope.inlineUpdate(savedStaff);
    });
  };

  $scope.undeleteStaff = function() {
    if ($scope.validateForms() === false) {
      ngToast.dismiss();
      ngToast.danger('Please fix invalid fields.');
      return;
    }

    removeHourlyRate();

    $scope.restoring = TimeStaff.restore($scope.staff);
    $scope.restoring.then(function(savedStaff) {
      // Callback to the staff list controller.
      $scope.inlineUpdate(savedStaff);
    });
  };

  // Function to allow the sub controllers to register forms that will be
  // varlidated before save
  $scope.registerForm = function(tab, form) {
    formControllers[tab] = form;
  };

  // Iterate the registered formControllers to ensure all staff details are valid.
  $scope.validateForms = function() {
    var isValid = true;
    angular.forEach(formControllers, function(formCtrl) {
      formCtrl.$setSubmitted();
      if (formCtrl.$invalid) {
        isValid = false;
      }
    });
    return isValid;
  };
}]);
